import { FormControl, TextField } from "@mui/material";
import React from "react";
import Swal from "sweetalert2";


import './Form433DResubmission.css';
import FormService from "../../Services/FormServices";


class Form433DResubmission extends React.Component<{}, { amount: string, validationError: string, token: string, redirectUrl: string }> {

    constructor(props_: any) {
        super(props_);
        this.state = {
            amount: '',
            validationError: '',
            token:'',
            redirectUrl:''
        }
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');
    
        if (!token) {
           Swal.fire("Error", "Token is missing.", "error");
           return;
        }
        this.setState({token: token});
      }

    validateDecimalInput = (value: string): string => {
        const regex = /^\d*\.?\d*$/;
        if (value === "") return "This field is required.";
        if (!regex.test(value)) return "Only numeric and decimal values are allowed.";
        return "";
    }

    inputHandler(event: any,) {
        const value = event.target.value;
        const error = this.validateDecimalInput(value);
        this.setState({ amount: value, validationError: error });

    }

    submitForm433DResubmission() {

        FormService.updateForm433DResubmission({
                userId: "2d9af70e-ef53-11ef-8c64-023eaa0ecbc3",
                monthlyAmnt: this.state.amount            
        }, this.state.token).then(r => {
            if (r.ok) {
                r.json().then((urlDetails:any) => {
                    this.setState({redirectUrl: urlDetails.redirectUrl});
                    Swal.fire({
                        title: 'Custom Modal',
                        html: '<p>This is <b>HTML</b> content inside the modal.</p>',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        didOpen: () => {
                          // Replace OK button text with anchor tag
                          const confirmButton = Swal.getConfirmButton();
                          if (confirmButton) {
                            confirmButton.innerHTML = `<a href= ${this.state.redirectUrl} style="color: white; text-decoration: none;" target="_blank">Go to Link</a>`;
                          }
                           this.setState({token:''});
                        }
                      });
                }); 
            }
        });
    }

    render() {
        return (
            <div>
                <h3 style={{textAlign:'center'}}>IRS Installment plan re-submission</h3>
                <div className="resubmission-container">
                    <p>Please enter the amount which IRS suggested through notification</p>

                    <FormControl id='et' sx={{ m: 1, minwidth: '100%',textAlign:'left' }}>
                        <TextField id="outlined-basic" label="Amount" variant="outlined"
                            value={this.state.amount}
                            onInput={(event) => this.inputHandler(event)}
                            error={Boolean(this.state.validationError)}
                            helperText={this.state.validationError} />
                    </FormControl>

                    {this.state.token && <button className="resubmission-Action-btn" 
                    onClick={(event) => this.submitForm433DResubmission()} ><p><b>Submit</b></p></button>}

                </div>
            </div>

        );
    }

}

export default Form433DResubmission;